import React from 'react';

interface MainContentProps {
  children: React.ReactNode;
  isCollapsed: boolean;
  onCloseSidebar?: () => void;
}

export function MainContent({ children, isCollapsed, onCloseSidebar }: MainContentProps) {
  const handleClick = (event: React.MouseEvent) => {
    // Only close sidebar if it's currently open (not collapsed)
    // and we're not clicking on an interactive element
    if (!isCollapsed && onCloseSidebar) {
      const target = event.target as HTMLElement;
      
      // Don't close if clicking on interactive elements
      if (
        target.tagName === 'BUTTON' ||
        target.tagName === 'INPUT' ||
        target.tagName === 'SELECT' ||
        target.tagName === 'TEXTAREA' ||
        target.tagName === 'A' ||
        target.closest('button') ||
        target.closest('input') ||
        target.closest('select') ||
        target.closest('textarea') ||
        target.closest('a') ||
        target.closest('[role="button"]') ||
        target.closest('.city-dropdown') ||
        target.closest('.tooltip') ||
        target.closest('.modal')
      ) {
        return;
      }
      
      onCloseSidebar();
    }
  };

  return (
    <main 
      className={`
        flex-1 overflow-y-auto transition-all duration-300 ease-in-out
        ${isCollapsed ? 'ml-0' : 'ml-0'}
      `}
      onClick={handleClick}
    >
      <div className="max-w-7xl mx-auto px-4 py-2">
        <div className="space-y-6">
          {children}
        </div>
      </div>
    </main>
  );
}